import { tdsConstants } from '../_constants';

const initialState = {
  tdss: [],
  errors: {}
};

export function tds(state = initialState, action) {
  switch (action.type) {

  case tdsConstants.TDS_OPTIONS_LOADED:
    return Object.assign({}, state, { options: action.data.actions.POST });

  case tdsConstants.TDSS_LOADED:
    return Object.assign({}, state, { tdss: action.data.results});

  case tdsConstants.TDS_CREATED:
    let { tdss } = state;
    tdss.unshift(action.data);
    return Object.assign({}, state, { tdss, message: 'Tds successfully created.' });

  case tdsConstants.TDS_LOADED:
    return Object.assign({}, state, { tds: action.data});

  case tdsConstants.TDS_UPDATED:
    tdss = state.tdss.slice();
    let idx = tdss.findIndex(item => item.id === action.data.id);
    tdss[idx] = action.data;
    return Object.assign({}, state, { tdss, message: 'Tds successfully updated.' });

  case tdsConstants.TDS_ERRORS:
    return Object.assign({}, state, { errors: action.errors });

  case tdsConstants.TDS_DELETED:
    tdss = state;
    idx = tdss.findIndex(item => item.id === action.data.id);
    delete tdss[idx];
    return Object.assign({}, state, { tdss, message: 'Tds successfully deleted.' });

  case tdsConstants.TDS_RESET:
    return Object.assign({}, state, { message: '', errors: {} });

  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/_reducers/tds.reducer.js